<template>
    <div id="RaiseNewCase">
        <a-spin :spinning="loading">
            <a-row>
                <a-col class="headerDesc">
                    <span class="descSub">{{caseTitle}}:</span>
                    <span>{{caseDesc}}  <span  v-if="pdfFileName" class="linkAction" @click="gotoPdfView">here</span> </span>
                </a-col>
            </a-row>

            <a-row v-if="responseIdentifiers.length" class="m-T-30 wordwrap">
                <a-col v-if="responseIdentifiers.length" :span="11">
                    <a-row>
                        <a-col class="subTitle">Identifiers</a-col>
                        <a-col v-for="(item, index) in responseIdentifiers" :key="index">
                            <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                         :data="item"></NormalInput>
                            <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'" :data="item"
                                          @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                        </a-col>
                    </a-row>
                    <a-row v-if="ResponseOutcome.length" style="margin-top: 80px">
                        <a-col class="subTitle">Response Outcome</a-col>
                        <a-col v-for="(item, index) in ResponseOutcome" :key="index+100">
                            <NormalInput isCanEdit="'false'"
                                         :data="item"></NormalInput>
                        </a-col>
                    </a-row>
                </a-col>

                <a-col v-if="responseRequesterInfo.length" :span="11" :offset="2">
                    <a-row>
                        <a-col class="subTitle">Requester Info</a-col>
                        <a-col v-for="(item, index) in responseRequesterInfo" :key="index+1000">
                            <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                         :data="item"></NormalInput>
                            <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'" :data="item"
                                          @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseRequestDetails.length || responseRequestDetailsComment.length "
                   class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    Request Detail
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col :span="11">
                            <a-row>
                                <a-col v-for="(item, index) in responseRequestDetails" :key="index+10000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>

                        </a-col>
                        <a-col :span="11" :offset="2">
                            <a-row>
                                <a-col v-for="(item, index) in responseRequestDetailsComment" :key="index +100000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseEDIMissing.length || responseEDIMissingComment.length " class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    EDI Missing
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col :span="11">
                            <a-row>
                                <a-col v-for="(item, index) in responseEDIMissing" :key="index+2000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>

                        </a-col>
                        <a-col :span="11" :offset="2">
                            <a-row>
                                <a-col v-for="(item, index) in responseEDIMissingComment" :key="index +3000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseRefuseReasons.length || responseRefuseReasonsComment.length " class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    Refuse Reasons
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col :span="11">
                            <a-row>
                                <a-col v-for="(item, index) in responseRefuseReasons" :key="index+4000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>

                        </a-col>
                        <a-col :span="11" :offset="2">
                            <a-row>
                                <a-col v-for="(item, index) in responseRefuseReasonsComment" :key="index +5000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseComment.length " class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    Comment
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col :span="11">
                            <a-row>
                                <a-col v-for="(item, index) in responseComment" :key="index+9000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseAttachmentInfo.length" class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    Attachment
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col>
                            <a-row>
                                <a-col v-for="(item, index) in responseAttachmentInfo" :key="index+11000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile">
                                    </NormalUpload>
                                </a-col>
                            </a-row>

                        </a-col>

                    </a-row>
                </a-col>
            </a-row>
            <a-row v-if="responseAddressReceived.length || responseAddressReceivedComment.length "
                   class="m-T-30 wordwrap">
                <a-col :span="24" class="subTitle">
                    Address Received from LENOVO via DESADV
                </a-col>
                <a-col :span="24">
                    <a-row class="m-T-30">
                        <a-col :span="11">
                            <a-row>
                                <a-col v-for="(item, index) in responseAddressReceived" :key="index+11000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile" @handleRemoveAction="removeFile"></NormalUpload>
                                </a-col>
                            </a-row>

                        </a-col>
                        <a-col :span="11" :offset="2">
                            <a-row>
                                <a-col v-for="(item, index) in responseAddressReceivedComment" :key="index +12000">
                                    <NormalInput :isCanEdit="isCanEdit" v-if="item.inputStyle !== 'upload'"
                                                 :data="item"></NormalInput>
                                    <NormalUpload :isCanEdit="isCanEdit" v-if="item.inputStyle === 'upload'"
                                                  :data="item"
                                                  @uploadFile="getUploadFile"
                                                  @handleRemoveAction="caseShowItemremoveFile"></NormalUpload>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>

            <a-row v-if="isCanEdit" class="m-T-30">
                <a-col :span="11" :offset="6">
                    <a-button type="primary" class="buttonCss" @click="saveDraft">Save Draft</a-button>
                    <a-button type="primary" class="buttonCss" @click="save">Submit</a-button>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>

<script>
    import {
        caseShowItem,
        PDFFIleConfig
    } from './raiseNewCaseConfig'

    import RaiseNewCaseItem from '../../components/RaiseNewCasetem'
    import RaiseNewCaseItemStyleOne from '../../components/RaiseNewCaseItemStyleOne'
    import {saveDrafRequest, commiteRequest, getViewDetail, getNewViewDetail} from './RaiseNewCaseApiMethod'
    import {checkInput} from '../../components/checkAllInput'
    import NormalInput from '../../components/NormalInput'
    import NormalUpload from '../../components/NormalUpload'
    import moment from "moment";

    export default {
        name: 'RaiseNewCase',
        components: {
            RaiseNewCaseItem,
            RaiseNewCaseItemStyleOne,
            NormalInput,
            NormalUpload
        },
        data() {
            return {
                pageType: '1',
                caseDesc: '',
                caseTitle: '',
                descriptionUrl: '',
                buyType: null,
                itemString: null,
                caseId: null,
                isCanEdit: false,
                loading: false,
                uuid: '',
                isRequestTag: '1',
                responseIdentifiers: [],
                responseRequestDetails: [],
                responseRequestDetailsComment: [],
                responseEDIMissing: [],
                responseEDIMissingComment: [],
                responseRequesterInfo: [],
                responseComment: [],
                ResponseOutcome: [],
                responseRefuseReasons: [],
                responseRefuseReasonsComment: [],
                responseAddressReceived: [],
                responseAddressReceivedComment: [],
                responseAttachmentInfo: [],
                responseData: [],
                isAllDataOk: true,
                attachment: null,
                attachment1: null,
                attachment2: null,
                attachment3: null,
                attachmentSize: 0,
                attachment1Size: 0,
                attachment2Size: 0,
                attachment3Size: 0,
                pdfFileName: '',
            }
        },
        destroyed() {

        },
        created() {
            if (this.$route.query.pageType) this.pageType = this.$route.query.pageType
            this.requestCommontData()
        },
        methods: {
            requestCommontData() {
                this.responseIdentifiers = []
                this.responseRequesterInfo = []
                this.responseRequestDetails = []
                this.responseRequestDetailsComment = []

                if (this.pageType === '1') {
                    this.buyType = this.$route.query.buyType
                    this.caseId = this.$route.query.caseId

                    this.isCanEdit = true

                    this.loading = true
                    getNewViewDetail(this.caseId, this.buyType).then(res => {
                        this.loading = false
                        this.buyType = res.buType
                        this.caseId = res.caseId
                        this.caseTitle = res.caseName
                        this.caseDesc = res.caseDesc
                        const fff = this.buyType + '-' + this.caseTitle
                        this.pdfFileName = PDFFIleConfig[fff.toLowerCase()]
                        var caseFields = res['caseFields']
                        if (Array.isArray(caseFields['Identifiers'])) {
                            this.responseIdentifiers = this.getItemShowInPage(caseFields['Identifiers'])
                        }
                        if (Array.isArray(caseFields['Requester info'])) {
                            this.responseRequesterInfo = this.getItemShowInPage(caseFields['Requester info'])
                            // this.setNewUserName(this.userName)
                        }
                        if (Array.isArray(caseFields['Refuse Reasons'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Refuse Reasons'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                        this.responseRefuseReasonsComment.push(reItem)
                                    } else {
                                        this.responseRefuseReasons.push(reItem)
                                    }
                                })
                            }
                        }

                        if (Array.isArray(caseFields['Response Outcome'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Response Outcome'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                        this.ResponseOutcome.push(reItem)
                                    } else {
                                        this.ResponseOutcome.push(reItem)
                                    }
                                })
                            }
                        }

                        if (Array.isArray(caseFields['EDI Missing'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['EDI Missing'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                        this.responseEDIMissingComment.push(reItem)
                                    } else {
                                        this.responseEDIMissing.push(reItem)
                                    }
                                })
                            }
                        }
                        if (Array.isArray(caseFields['Request Detail'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Request Detail'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                        this.responseRequestDetailsComment.push(reItem)
                                    } else {
                                        this.responseRequestDetails.push(reItem)
                                    }
                                })
                            }
                        }

                        if (Array.isArray(caseFields['Comment'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Comment'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    this.responseComment.push(reItem)
                                })
                            }
                        }

                        if (Array.isArray(caseFields['Attachment'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Attachment'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    this.responseAttachmentInfo.push(reItem)
                                })
                            }
                        }

                        if (Array.isArray(caseFields['Address Received from LENOVO via DESADV'])) {
                            var resultDetails = this.getItemShowInPage(caseFields['Address Received from LENOVO via DESADV'])
                            if (Array.isArray(resultDetails)) {
                                resultDetails.forEach(reItem => {
                                    if (reItem.title === 'Comments' ||
                                        reItem.title === 'Customer Contact Emai' ||
                                        reItem.title === 'Customer Phone' ||
                                        reItem.title === 'Customer Reference Number') {
                                        this.responseAddressReceivedComment.push(reItem)
                                    } else {
                                        this.responseAddressReceived.push(reItem)
                                    }
                                })
                            }
                        }
                    })
                } else {
                    this.uuid = this.$route.query.uuid
                    if (this.uuid) {
                        this.loading = true
                        getViewDetail(this.uuid).then(res => {
                            this.loading = false
                            this.isCanEdit = res.edit === 1
                            this.buyType = res.buType
                            this.caseId = res.caseId
                            this.caseTitle = res.caseName
                            this.caseDesc = res.caseDesc
                            const fff = this.buyType + '-' + this.caseTitle
                            this.pdfFileName = PDFFIleConfig[fff.toLowerCase()]

                            var param = res.params
                            var caseFields = param
                            if (Array.isArray(caseFields)) {
                                caseFields.forEach(item => {
                                    if (item.title === 'Identifiers') {
                                        this.responseIdentifiers = this.getItemShowInDetailPage(item.fields)
                                    }
                                    if (item.title === 'Requester info') {
                                        this.responseRequesterInfo = this.getItemShowInDetailPage(item.fields)
                                    }
                                    if (item.title === 'Refuse Reasons') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                                    this.responseRefuseReasonsComment.push(reItem)
                                                } else {
                                                    this.responseRefuseReasons.push(reItem)
                                                }
                                            })
                                        }
                                    }
                                    if (item.title === 'Comment') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                this.responseComment.push(reItem)
                                            })
                                        }
                                    }

                                    if (item.title === 'Request Detail') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                                    this.responseRequestDetailsComment.push(reItem)
                                                } else {
                                                    this.responseRequestDetails.push(reItem)
                                                }
                                            })
                                        }
                                    }
                                    if (item.title === 'Attachment') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                this.responseAttachmentInfo.push(reItem)
                                            })
                                        }
                                    }
                                    if (item.title === 'Response Outcome') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                this.ResponseOutcome.push(reItem)
                                            })
                                        }
                                    }
                                    if (item.title === 'EDI Missing') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                if (reItem.title === 'Comments' || reItem.title === 'Root Cause of Damage') {
                                                    this.responseEDIMissingComment.push(reItem)
                                                } else {
                                                    this.responseEDIMissing.push(reItem)
                                                }
                                            })
                                        }
                                    }

                                    if (item.title === 'Address Received from LENOVO via DESADV') {
                                        var resultDetails = this.getItemShowInDetailPage(item.fields)
                                        if (Array.isArray(resultDetails)) {
                                            resultDetails.forEach(reItem => {
                                                if (reItem.title === 'Comments' ||
                                                    reItem.title === 'Customer Contact Email' ||
                                                    reItem.title === 'Customer Phone' || reItem.title === 'Customer Reference Number') {
                                                    this.responseAddressReceivedComment.push(reItem)
                                                } else {
                                                    this.responseAddressReceived.push(reItem)
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            },
            getItemShowInDetailPage(resConfig) {
                var result = []
                resConfig.forEach(item => {
                    if (!caseShowItem[item.fieldName]) {
                        // console.log('caseShowItem do not has item : ', item)
                    } else {
                        let selectItem = this.getNewShowInputItem(item['fieldName']);
                        // Name、Phone如果有返回的value，则使用返回的value，否则就不做操作
                        if (selectItem.title === 'Name') {
                            selectItem.value = item.value ? item.value : ''
                        } else if (selectItem.title === 'Phone') {
                            selectItem.value = item.value ? item.value : ''
                        } else {
                            // 如果有返回的value，则使用返回的value，否则就使用设置的默认value
                            selectItem.value = item.value ? item.value : selectItem.value
                        }
                        if (selectItem.inputStyle === 'select') {
                            if (item.value) {
                                selectItem.value = item.value
                            } else {
                                selectItem.value = []
                            }

                            if (item.params) {
                                var configSelect = Object.keys(item.params)
                                if (Array.isArray(configSelect)) {
                                    var selectArray = [];
                                    configSelect.forEach(sI => {
                                        selectArray.push({
                                            name: sI,
                                            value: item.params[sI]
                                        })
                                    });
                                    selectItem.selectArray = selectArray
                                }
                            } else {
                                selectItem.selectArray = []
                            }
                        }
                        selectItem.valid = item.exits ? item.exits : false
                        selectItem.title = item.title ? item.title : false
                        selectItem.isOk = true
                        selectItem.isShowErrorMsg = false
                        result.push(selectItem)
                    }
                })
                return result
            },
            // new 的情形
            getItemShowInPage(resConfig) {
                var result = []
                resConfig.forEach(item => {
                    if (!caseShowItem[item.name]) {
                        // console.log('caseShowItem do not has item : ', item)
                    } else {
                        // const caseItem = caseShowItem[item.name]
                        // var selectItem = {
                        //     title: caseItem.title,
                        //     inputStyle: caseItem.inputStyle,
                        //     placeholder: caseItem.placeholder,
                        //     valid: caseItem.valid,
                        //     value: caseItem.value,
                        //     isOk: caseItem.isOk,
                        //     code: caseItem.code,
                        //     errorMsg: caseItem.errorMsg
                        // }
                        // var selectItem = caseShowItem[item.name]
                        let selectItem = this.getNewShowInputItem(item.name)
                        if (selectItem) {
                            if (selectItem.title === 'Name') {
                                selectItem.value = item.value ? item.value : this.userName
                            } else if (selectItem.title === 'Phone') {
                                selectItem.value = item.value ? item.value : this.$store.getters.getUserPhone
                            } else {
                                selectItem.value = item.value
                            }
                            if (selectItem.inputStyle === 'select') {
                                if (item.value) {
                                    selectItem.value = item.value
                                } else {
                                    selectItem.value = []
                                }
                                if (item.params) {
                                    var configSelect = Object.keys(item.params)
                                    if (Array.isArray(configSelect)) {
                                        var selectArray = []
                                        configSelect.forEach(sI => {
                                            selectArray.push({
                                                name: sI,
                                                value: item.params[sI]
                                            })
                                        })
                                        selectItem.selectArray = selectArray
                                    }
                                } else {
                                    selectItem.inputStyle = 'text'
                                    selectItem.selectArray = []
                                }
                            }
                            selectItem.valid = item.exits ? item.exits : false
                            selectItem.isOk = true
                            selectItem.isShowErrorMsg = false
                            result.push(selectItem)
                        }
                    }
                })
                return result
            },
            getNewShowInputItem(name) {
                if (name && name.length > 0) {
                    const caseItem = caseShowItem[name]
                    var selectItem = {
                        title: caseItem.title,
                        name: caseItem.name,
                        inputStyle: caseItem.inputStyle,
                        placeholder: caseItem.placeholder,
                        valid: caseItem.valid,
                        value: caseItem.value,
                        isOk: caseItem.isOk,
                        code: caseItem.code,
                        errorMsg: caseItem.errorMsg
                    }
                    return selectItem
                } else {
                    return null
                }

            },
            getUploadFile(fileData) {
                // console.log('getUploadFile : ', fileData);
                const item = fileData.item
                if (item.title === 'Attachment') {
                    this.attachment = fileData.file
                    this.attachmentSize = fileData.size
                } else if (item.title === 'Attachment1') {
                    this.attachment1 = fileData.file
                    this.attachment1Size = fileData.size
                } else if (item.title === 'Attachment2') {
                    this.attachment2 = fileData.file
                    this.attachment2Size = fileData.size
                } else if (item.title === 'Attachment3') {
                    this.attachment3 = fileData.file
                    this.attachment3Size = fileData.size
                }
            },
            removeFile(fileData) {
                const item = fileData.item
                this.responseAttachmentInfo.forEach(ite => {
                    if (ite.title === item.title ) {
                        ite.value = null
                    }
                })
                if (item.title === 'Attachment') {
                    this.attachment = null
                    this.attachmentSize = 0
                } else if (item.title === 'Attachment1') {
                    this.attachment1 = null
                    this.attachment1Size = 0
                } else if (item.title === 'Attachment2') {
                    this.attachment2 = null
                    this.attachment2Size = 0
                } else if (item.title === 'Attachment3') {
                    this.attachment3 = null
                    this.attachment3Size = 0
                }
            },
            saveDraft() {
                const sizeM = (this.attachmentSize + this.attachment1Size + this.attachment2Size + this.attachment3Size) / 1024 / 1024
                if (sizeM > 5) {
                    this.$error({
                        title: 'Error',
                        content: 'Files must smaller than 5 MB!',
                    });
                    return
                }
                const param = this.getRequestData()
                if (!param.isOk) {
                    return
                }
                const formData = this.getSendParam()
                const self = this
                this.loading = true
                saveDrafRequest(this.buyType, formData).then(res => {
                    self.loading = false
                    const err = res['errors']
                    const war = res['warnings']
                    if ((err && err.length > 0) || (war && war.length > 0)) {
                        var msg = err[0] ? err[0] : (war[0] ? war[0] : 'Error')
                        // this.$message.error(msg)
                        this.$error({
                            title: 'Error',
                            content: msg,
                        });
                    } else {
                        this.$message.success('Success')
                        this.$router.go(-1)
                    }
                })
            },
            save() {
                const sizeM = (this.attachmentSize + this.attachment1Size + this.attachment2Size + this.attachment3Size) / 1024 / 1024

                if (sizeM > 5) {
                    this.$error({
                        title: 'Error',
                        content: 'Files must smaller than 5 MB!',
                    });
                    return
                }
                const param = this.getRequestData()
                if (Object.keys(param.param).length === 2) {
                    return
                }
                if (!param.isOk) {
                    return
                }
                const self = this

                this.$confirm({
                    title: 'Submit',
                    content: 'Please note this action cannot be withdrawn after submission!',
                    cancelText: 'Yes',
                    icon: 'exclamation-circle',
                    onCancel() {
                        self.destroyAll()
                        self.submitSendRequest()
                    },
                    okText: 'No',
                    okButtonProps: {props: {type: ''}},
                    cancelButtonProps: {props: {type: 'primary'}},
                    onOk() {
                        self.destroyAll()
                    }
                })
            },
            getSendParam() {
                // console.log('getSendParam');
                const param = this.getRequestData()
                if (!param.isOk) {
                    return
                }
                const formData = new FormData()
                var isAttachment = false
                if (this.attachment) {
                    this.attachment.forEach(file => {
                        isAttachment = true
                        if (file.originFileObj) {
                            formData.append('attachment', file.originFileObj)
                        } else {
                            formData.append('attachment', file)
                        }
                    })
                }

                if (this.attachment1) {
                    this.attachment1.forEach(file => {
                        isAttachment = true
                        if (file.originFileObj) {
                            formData.append('attachment1', file.originFileObj)
                        } else {
                            formData.append('attachment1', file)
                        }
                    })
                }
                if (this.attachment2) {
                    this.attachment2.forEach(file => {
                        isAttachment = true
                        if (file.originFileObj) {
                            formData.append('attachment2', file.originFileObj)
                        } else {
                            formData.append('attachment2', file)
                        }
                    })
                }
                if (this.attachment3) {
                    this.attachment3.forEach(file => {
                        isAttachment = true
                        if (file.originFileObj) {
                            formData.append('attachment3', file.originFileObj)
                        } else {
                            formData.append('attachment3', file)
                        }
                    })
                }
                var sendParameters = {
                    uuid: this.uuid,
                    caseId: this.caseId,
                    params: param.param
                }
                formData.append('carrierRequest', JSON.stringify(sendParameters))
                return formData
            },
            submitSendRequest() {
                const formData = this.getSendParam()
                this.loading = true
                commiteRequest(this.buyType, formData).then(res => {
                    this.loading = false
                    const err = res['errors']
                    const war = res['warnings']
                    if ((err && err.length > 0) || (war && war.length > 0)) {
                        var msg = err[0] ? err[0] : (war[0] ? war[0] : 'Error')
                        this.$error({
                            title: 'Error',
                            content: msg,
                        });
                    } else {
                        this.$message.success('Success')
                        this.$router.go(-1)
                    }

                }).catch(error => {
                    // console.log(' error : ', error)
                })
            },
            destroyAll() {
                this.$destroyAll()
            },
            getRequestData() {
                this.checkData(this.responseIdentifiers)
                this.checkData(this.responseComment)
                this.checkData(this.responseRequestDetails)
                this.checkData(this.responseRequestDetailsComment)
                this.checkData(this.responseRequesterInfo)
                this.checkData(this.responseRefuseReasons)
                this.checkData(this.responseRefuseReasonsComment)
                this.checkData(this.responseAttachmentInfo)
                this.checkData(this.responseEDIMissing)
                this.checkData(this.responseEDIMissingComment)
                this.checkData(this.responseAddressReceived)
                this.checkData(this.responseAddressReceivedComment)

                const param = {}
                var isOk = true
                if (this.responseIdentifiers.length > 0) {
                    this.responseIdentifiers.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseComment.length > 0) {
                    this.responseComment.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseRequestDetails.length > 0) {
                    this.responseRequestDetails.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseRequestDetailsComment.length > 0) {
                    this.responseRequestDetailsComment.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseRequesterInfo.length > 0) {
                    this.responseRequesterInfo.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseRefuseReasons.length > 0) {
                    this.responseRefuseReasons.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseRefuseReasonsComment.length > 0) {
                    this.responseRefuseReasonsComment.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseAttachmentInfo.length > 0) {
                    this.responseAttachmentInfo.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseAddressReceived.length > 0) {
                    this.responseAddressReceived.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseAddressReceivedComment.length > 0) {
                    this.responseAddressReceivedComment.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseEDIMissing.length > 0) {
                    this.responseEDIMissing.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }
                if (this.responseEDIMissingComment.length > 0) {
                    this.responseEDIMissingComment.forEach(res => {
                        if (res.code) {
                            param[res.code] = this.getSendMsg(res)
                        }
                        if (!res.isOk) {
                            isOk = false
                        }
                    })
                }

                return {
                    param: param,
                    isOk: isOk
                }
            },
            getSendMsg(res) {
                var value = ''
                if (res.inputStyle === 'date') {
                    var a = moment(res.value).utc(false).format('YYYY-MM-DD')
                    a = a + ' ' + '00:00:00'
                    value = this.$moment(a).utc(false)
                } else if(res.inputStyle === 'dateTime') {

                } else if (res.inputStyle === 'time') {
                    value = this.$moment(res.value).utc(false)
                } else if (res.inputStyle === 'upload') {
                    value = res.value ? res.value : null
                } else if (res.inputStyle === 'number') {
                    value = parseFloat(res.value)
                } else if (res.inputStyle === 'select') {
                    if (res.value) {
                        if (typeof res.value === 'number') {
                            value = res.value ? res.value : null
                        } else if (typeof res.value === 'string') {
                            value = res.value ? res.value : null
                        } else {
                            if (res.value.length > 0) {
                                value = res.value ? res.value : null
                            } else {
                                value = null
                            }
                        }
                    } else {
                        value = null
                    }
                } else {
                    value = res.value ? res.value : null
                }

                return value
            },
            checkData(requetData) {
                if (Array.isArray(requetData)) {
                    requetData.forEach(item => {
                        if (item.title === 'Name') {
                            if (item.value) {
                                item.isOk = true
                            }
                        } else if (item.title === 'Email') {
                            if (item.value) {
                                this.setSearchHistory(item.value, item)
                            }
                        } else {
                            this.checkItem(item)
                        }
                        item.isShowErrorMsg = item.valid ? (item.isOk ? item.isOk : false) : false
                    })
                }
            },

            setSearchHistory(searchString, data) {
                const name = this.$store.getters.getUserName + data.inputStyle + 'History'
                var saveObj = this.getSearchHistory(data)
                saveObj[searchString] = searchString
                const saveString = JSON.stringify(saveObj)
                localStorage.setItem(name, saveString)
            },
            getSearchHistory(data) {
                const name = this.$store.getters.getUserName  + data.inputStyle + 'History'
                const localSave = localStorage.getItem(name) ? localStorage.getItem(name) : '';
                if (localSave) return JSON.parse(localSave)
                return {}
            },
            checkItem(data) {
                if (data.valid) {
                    if (data.inputStyle === 'date' || data.inputStyle === 'dateTime') {
                        if (data.value) {
                            const dataString = this.$moment(data.value).utc(false)
                            if (dataString) {
                                data.isOk = true
                            } else {
                                data.isOk = false
                            }
                        } else {
                            data.isOk = false
                        }
                    } else if (data.inputStyle === 'time') {
                        if (data.value) {
                            data.isOk = true
                        } else {
                            data.isOk = false
                        }
                    } else if (data.inputStyle === 'upload') {
                        data.isOk = true
                    } else {
                        checkInput(data)
                    }
                } else {
                    data.isOk = true
                }
            },
            setNewUserName(userName) {
                if (Array.isArray(this.responseRequesterInfo)) {
                    this.responseRequesterInfo.forEach(item => {
                        if (item.title === "Name") {
                            item.value = userName
                        }
                    })
                }
            },
            gotoPdfView() {
                if (this.pdfFileName && this.pdfFileName.length > 0) {
                    let routeData = window.location.origin + '/#/pdf?pdfName=' + this.pdfFileName
                    window.open(routeData, '_blank');
                }
                // var title = '/carrier/' + this.buyType + '- ' + this.caseTitle

            }
        },
        computed: {
            userName() {
                return this.$store.state.userInfo.userName
            }
        },
        watch: {
            userName(newVal, oldVal) {
                if (newVal) {
                    this.setNewUserName(newVal)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #RaiseNewCase {
        text-align: left;
        padding-bottom: 40px;

        .headerDesc {
            border: 1px solid #91d5ff;
            background-color: #e6f7ff;
            padding: 10px;
            font-weight: 400;

            .descSub {
                font-weight: 800;
            }
        }

        .subTitle {
            padding: 5px;
            border-bottom: 1px solid #91d5ff;
            color: #027DB4;
            font-weight: 800;
            font-size: 16px;
        }

        .m-T-30 {
            margin-top: 30px;
        }

        .wordwrap {
            word-wrap: break-word;
            padding: 10px;
        }

        .buttonCss {
            margin-left: 20px;
            font-size: 14px;
            font-weight: 800;
        }

        .linkAction {
            color: #1890ff;
            font-size: 14px;
            font-weight: 500;
        }
    }

</style>
